enum SettingsRouteName {
  AUTO_CLEARING = 'auto-clearing',
  BETA = 'beta',
  CLICK_API_SETTINGS = 'click-api-settings',
  COLUMNS_SETTINGS = 'columns-settings',
  FEEDBACK_SETTINGS = 'feedback-settings',
  IMPORT_EXPORT_SETTINGS = 'import-export-settings',
  INTEGRATION = 'integration',
  LANDING_PAGE_PROTECT_SETTINGS = 'landing-page-protect-settings',
  POSTBACK_PROCESSING_SETTINGS = 'postback-processing-settings',
  PUBLIC_API_SETTINGS = 'public-api-settings',
  SETTINGS = 'settings',
  STATS_SETTINGS = 'stats-settings',
  TRACKING_LINKS_SETTINGS = 'tracking-links-settings',
  UI_SETTINGS = 'ui-settings',
  URL_CUSTOMIZATION_SETTINGS = 'url-customization-settings',
  USER_SETTINGS = 'user-settings',
}

export default SettingsRouteName;
